import { createSlice } from "@reduxjs/toolkit";
import { 
  getPatientFlow, 
  createPatientFlow, 
  updatePatientFlow, 
  deletePatientFlow,
  clearLocalActivePatientFlow
} from "./actions"; 

export const initialState = {
  patientFlow: { 
    id: '', 
    prompt: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'patientFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getPatientFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPatientFlow.fulfilled, (state, action) => {
        const { patient_flow } = action.payload;
        const patientFlow = { ...state.patientFlow, ...patient_flow };

        state.loading = false;
        state.patientFlow = patientFlow;
      })
      .addCase(getPatientFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createPatientFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPatientFlow.fulfilled, (state, action) => {
        const { patient_flow } = action.payload;

        state.loading = false;
        state.patientFlow = patient_flow;       
      })
      .addCase(createPatientFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updatePatientFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePatientFlow.fulfilled, (state, action) => {
        const { status, patient_flow } = action.payload;
        const updatedPatientFlow = { ...state.patientFlow, ...patient_flow };

        state.loading = false;
        if (status === 204) state.patientFlow = updatedPatientFlow;       
      })
      .addCase(updatePatientFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deletePatientFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePatientFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.patientFlow = initialState.patientFlow;       
      })
      .addCase(deletePatientFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActivePatientFlow, state => {
        state.patientFlow = initialState.patientFlow;
      })
  }
})

export default slice.reducer;